import { mapState } from 'vuex'

export default {
  name: 'FormatService',
  computed: {
    ...mapState([
      'branchTranslations',
      'selectedLanguage'
    ])

  },
  watch: {
    selectedLanguage () {
    }
  },
  methods: {
    getBranchAddressBranchSelection:
    function (branch) {
      var formatted = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].names[this.selectedLanguage.lang] ? this.branchTranslations[branch.id].names[this.selectedLanguage.lang] : branch.name
      if (branch.addressCity) { formatted += ', ' + branch.addressCity }
      return formatted
    },
    getBranchAddressBranchCard:
    function (branch) {
      var formatted = branch.addressLine1
      if (branch.addressLine2) { formatted += ', ' + branch.addressLine2 }
      if (branch.addressZip) { formatted += ', ' + branch.addressZip }
      if (branch.addressCity) { formatted += ', ' + branch.addressCity }
      return formatted
    }
  }
}
